/* eslint-disable camelcase */
export default {
	change_order_number: '变更单号',
	merchant_info_change: '商户号信息变更',
	change_order_status: '变更单状态',
	data_change_type: '变更类型',
	change_ou: '变更主体',
	associated_merchant_number: '关联商户号',
	change_applicant: '变更发起人',
	change_description: '变更说明',
	change_content: '变更内容',
	base_info: '基本信息',
	qualification_information: '资质信息',
	change_date: '变更日期',
	reason_for_change: '变更原因',
	merchant: '商户号'
};
